import { useRef, useState } from "react";
import { UploadCloud, FileText, X } from "lucide-react";

export default function FileDropzone({ onFile, accept = ".csv,.txt,.xlsx,.xls", testid = "file-dropzone", onClear }) {
  const [drag, setDrag] = useState(false);
  const [name, setName] = useState("");
  const ref = useRef(null);

  const handle = (f) => {
    if (!f) return;
    setName(f.name);
    onFile?.(f);
  };

  const clear = (e) => {
    e.stopPropagation();
    setName("");
    if (ref.current) ref.current.value = "";
    onClear?.();
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        const f = e.dataTransfer.files?.[0];
        handle(f);
      }}
      onClick={() => ref.current?.click()}
      data-testid={testid}
      className={`relative border-2 border-dashed rounded-xl p-10 text-center cursor-pointer transition-all ${
        drag ? "border-turq-500 bg-turq-50" : "border-turq-200 bg-turq-50/40 hover:bg-turq-50 hover:border-turq-300"
      }`}
    >
      <input
        ref={ref}
        type="file"
        accept={accept}
        className="hidden"
        onChange={(e) => handle(e.target.files?.[0])}
        data-testid={`${testid}-input`}
      />
      {name ? (
        <div className="flex flex-col items-center gap-2">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-turq-600 to-cyan-500 flex items-center justify-center shadow-md">
            <FileText className="w-5 h-5 text-white" />
          </div>
          <div className="font-mono text-sm text-slate-900 mt-1">{name}</div>
          <div className="tiny-label">Değiştirmek için tıklayın</div>
          <button onClick={clear} className="absolute top-3 right-3 p-1 rounded-md text-slate-400 hover:text-red-600 hover:bg-white" title="Kaldır">
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3">
          <div className="w-14 h-14 rounded-2xl bg-white border border-turq-100 flex items-center justify-center shadow-sm">
            <UploadCloud className="w-6 h-6 text-turq-600" strokeWidth={1.8} />
          </div>
          <div className="font-display font-bold text-xl text-slate-900">Dosyayı buraya bırakın</div>
          <div className="text-sm text-slate-500">veya seçmek için tıklayın · <span className="text-turq-700 font-semibold">CSV · XLSX · XLS · TXT</span> · maks 100MB / 200.000 satır</div>
        </div>
      )}
    </div>
  );
}
